export type LookupsCommonType = {
  label: string;
  value: string | number;
  metadata?: Record<string, unknown>;
};

export enum LookupType {
  TITLES = 'titles',
  SOURCE_OF_FUNDS = 'source-of-funds',
  ACCOUNT_PURPOSE = 'account-purpose',
  COUNTRIES = 'countries',
  NO_TIN_REASONS = 'no-tin-reasons',
  SAVINGS_PRODUCTS = 'savings-products',
  SAVINGS_PRODUCTS_RENEWAL = 'savings-products-renewal',
  SUPPORT_CHAT_SUBJECTS = 'support-chat-subjects',
  COMPANIES_HOUSE_DIRECTORS = 'companies-house-directors',
  INDUSTRY_CATEGORIES = 'industry-categories',
  DEFAULT = 'default',
}
